if (document.querySelector("div[data-drupal-messages] a") && document.querySelector("div[data-drupal-messages] a").getAttribute("href").indexOf("/security/tfa") > -1){
    document.querySelector("div[data-drupal-messages] .close").remove();
    document.querySelector("div[data-drupal-messages]").style.height = "100vh";
    document.querySelector("div[data-drupal-messages]").style.maxHeight = "100vh";
} else if (document.querySelector("div[data-drupal-messages]")) {
    document.querySelector("div[data-drupal-messages] .close").addEventListener("click", (e) => {
      e.stopPropagation();
      e.preventDefault();
      document.querySelector("div[data-drupal-messages]").remove();
    })
}
